import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ProjectActions.module.scss';
import Swal from 'sweetalert2';
import { hideCanvas } from '~loader';
import { onErrorShowMessage } from '~src/errors';

async function deleteProjectHandler(canvasId, setIsDeleted) {
  try {
    Swal.fire({
      text: 'Sto eliminando il progetto...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      confirmButtonColor: '#278e8e',
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await hideCanvas(canvasId);
    setIsDeleted(true);
    Swal.hideLoading();
    Swal.fire({
      title: 'Eliminato!',
      html: 'Il progetto &egrave; stato eliminato con successo.',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
}

function ProjectActions(props) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const onDocClick = (e) => {
      if (!triggerRef.current) return;
      if (triggerRef.current.contains(e.target)) return;
      setIsOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [isOpen]);

  return (
    <div
      ref={triggerRef}
      className={`sidebar-context-menu-trigger ${styles.cardTrigger} ${
        isOpen ? 'is-open' : ''
      }`}
      data-menu-align="left"
      onClick={(e) => {
        e.stopPropagation();
        setIsOpen((v) => !v);
      }}
      aria-haspopup="menu"
      aria-expanded={isOpen}
      aria-label="Azioni progetto"
      title="Azioni progetto"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Escape') setIsOpen(false);
      }}
    >
      {/* Inline SVG icon (three dots). Avoid JS SVG injection and CSS background-image. */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
        />
      </svg>
      <div
        className={`sidebar-context-menu ${isOpen ? 'is-open' : ''}`}
        role="menu"
      >
        <a
          href={`/canvas/${props.objectId}`}
          data-navigo
          className="item"
          role="menuitem"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(false);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
          <span>Apri</span>
        </a>
        <button
          type="button"
          className="item item--danger"
          role="menuitem"
          onClick={(e) => {
            e.stopPropagation();
            deleteProjectHandler(props.objectId, props.setIsDeleted);
            setIsOpen(false);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width={16}
            height={16}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
            />
          </svg>
          <span>Elimina</span>
        </button>
      </div>
    </div>
  );
}

ProjectActions.propTypes = {
  objectId: PropTypes.string,
  setIsDeleted: PropTypes.func,
};

export default ProjectActions;
